import { Add } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigNoSynthesis: React.FC = () => {
  const { setValue } = useFormConfigContext();
  return (
    <>
      <Typography className="italic">
        Une synthèse est un court texte dans lequel vous pouvez injecter
        certaines valeurs des extractions une fois le traitement terminé.
      </Typography>
      <div className="flex justify-center">
        <Button
          variant="contained"
          onClick={() => setValue("config.synthesis", "")}
          className="gap-2"
        >
          <Add />
          Synthèse
        </Button>
      </div>
    </>
  );
};
export default ConfigNoSynthesis;
